const selectors = {
  container: "collection-assembly",
  carousel: {
    container: "collection-assembly--carousel",
    card: "collection-assembly--carousel--card",
  },
};

export default selectors;
